export default __webpack_public_path__ + "static/media/img_agenda.c2a2de67.png";